import React from "react";
import {
  Article,
  Section,
  SectionHeader,
  SectionTitle,
} from "../../styles/ResumeStyles";

const Experience = () => {
  return (
    <Article>
      <SectionTitle>Experience</SectionTitle>
      <Section>
        <SectionHeader>
          <p className="bold">Full Stack Developer</p>
          <p>Jify - Mumbai</p>
          <p>Apr 2022 - Present</p>
        </SectionHeader>

        <div>
          <ul>
            <li>
              Develop and maintain the admin dashboard used by the Customer
              Success and Credit Ops teams
            </li>
            <li>
              Utilize React with Typescript for the frontend and AWS with NodeJS
              for the backend
            </li>
          </ul>
        </div>
      </Section>

      <Section>
        <SectionHeader>
          <p className="bold">Media Director</p>
          <p>Byju's - Bangalore</p>
          <p>Jan 2021 - Dec 2021</p>
        </SectionHeader>

        <div>
          <ul>
            <li>
              Directed design and content for outsourced projects, setting
              quality standards and streamlining the production pipeline
            </li>
            <li>
              Reduced production time from 3 weeks to 1 week through efficient
              project management
            </li>
            <li>
              Created wireframes and prototypes, and converted complex user
              flows into prototypes
            </li>
          </ul>
        </div>
      </Section>

      <Section>
        <SectionHeader>
          <p className="bold">Creative Associate</p>
          <p>Byju's - Bangalore</p>
          <p>Jul 2019 - Jan 2021</p>
        </SectionHeader>

        <div>
          <ul>
            <li>
              Co-led the largest project by volume in the company, directing
              design and content for outsourced projects
            </li>
            <li>
              Managed delivery and optimization of artwork, and worked on
              editing, animation, and motion graphics
            </li>
          </ul>
        </div>
      </Section>
    </Article>
  );
};

export default Experience;
